import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/project/byTenant/project.byTenant.query.gql"
import type {
  ProjectByTenantQuery,
  ProjectByTenantQueryVariables,
} from "@/v2-backoffice-client/project/byTenant/__types__/project.byTenant.query"

type Options = QueryHookOptions<
  ProjectByTenantQuery,
  ProjectByTenantQueryVariables
>

export function useProjectByTenantQuery(options?: Options) {
  return useQuery<ProjectByTenantQuery, ProjectByTenantQueryVariables>(
    query,
    options,
  )
}
